import { storageDateFormat } from '@/core';
import moment from 'moment';

export default function() {
	return {
		dateType: 'etd',
		date: {
			from: moment().startOf('day')
				.subtract(7,'d')
				.format(storageDateFormat),
			to:''
		},
		fromDespatchParty: [],
		toDeliveryParty: [],
		customer: [],
		goodsTypes: [],
		orderTypes: [],
		hasAta: { value: undefined, label: 'showAny' },
		hasAtd: { value: undefined, label: 'showAny' },
		economicalStatus: [],
		orderStatus: [],
		references: [],
		referencesText: '',
		waybillNumber: []
	};
}
